export const getEncounter = 'getEncounter'
export const visitType = 'visit-type'
export const general = 'general'
export const dental = 'dental'
export const physio = 'physio'
export const odooPharmacyLink = 'odooPharmacyLink'
export const SaleOrderOdooLink = 'SaleOrderOdooLink'
export const getVisitsByDateIntent = 'getVisitsByDate'
export const visitsCountOP = 'visitsCountOP'
export const fetchAppointments = 'fetchAppointments'
export const cancelled = 'cancelled'
export const checkedIn = 'checked-in'
export const paid = 'Paid'
export const loading = 'loading'
export const fulfilled = 'fulfilled'
export const appointments = 'appointments'
export const PageSize = [10, 20, 50, 100]
export const proposed = 'proposed'
